import { Component, OnInit } from "@angular/core";
import { RootScopeService } from "src/app/core/services/root-scope.service";
import { HomeService } from "./home.service";
import { SupportContact } from "../../Models/common/SupportContact";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false,
})

export class HomeComponent implements OnInit {
    supportContacts: SupportContact[] = [];
    supportModalOpen = false;
    tileDropdownOpen = false;
    selectedTile = '';
    selectedContact: SupportContact | null = null;

    constructor(public rootScope: RootScopeService, private homeService: HomeService) {}

    ngOnInit(): void {
        this.homeService.getSupportContacts().subscribe({
            next: (contacts) => this.supportContacts = contacts,
            error: (err) => console.error('Failed to load support contacts', err)
        });
    }

    get userName(): string {
        return this.rootScope.globals.currentUserName ? this.rootScope.globals.currentUserName : '';
    }

    openSupportModal(): void {
        this.selectedTile = '';
        this.selectedContact = null;
        this.tileDropdownOpen = false;
        this.supportModalOpen = true;
    }

    closeSupportModal(): void {
        this.supportModalOpen = false;
    }

    selectTileFromDropdown(tileName: string): void {
        this.selectedTile = tileName;
        this.selectedContact = this.supportContacts.find(c => c.tileName === tileName) || null;
        this.tileDropdownOpen = false;
    }
}